import _ from "lodash";
import { fetchApi } from "../../utils";

const mapField = data => {
  return {
    ...data,
    video: _.get(data, "desktop_video"),
    imageBanner: _.get(data, "media_desktop_image_data.full_file_path"),
    imageBannerMobile: _.get(data, "media_mobile_image_data.full_file_path")
  };
};

const fetchNewsPageApi = () => {
  return fetchApi("page/news")
    .then(res => _.get(res, "data"))
    .then(mapField);
};

export { fetchNewsPageApi };



// WEBPACK FOOTER //
// ./src/services/page/newspage.js